import { useEffect, useRef, useState } from "react";
import { createSelectOptions } from "../../utils/various";
import { useNavigate } from "react-router-dom";
import { changeSessionData } from "../../store/reducers/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import Button from "../UI/Button";
import Alert from "../UI/Alert";

const Register = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { sessionData } = useSelector(state => state.session);
    useEffect(() => {
        if (sessionData) {
            navigate('/');
        }
    }, [sessionData, navigate]);

    const userRef = useRef();
    const passRef = useRef();


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!userRef.current.value || !passRef.current.value) {
            setError('Todos los campos son obligatorios');
            setTimeout(() => {
                setError(null);
            }, 5000);
            return;
        }

        let user = {
            usuario: userRef.current.value,
            password: passRef.current.value,
        }
        setLoading(true);

        /*
        registerUser(user)
            .then(res => {
                if (res.data.codigo === 200) {
                    let { apiKey, id } = res.data;
                    dispatch(changeSessionData({ apiKey, userId: id }));
                    navigate('/');
                }
            })
            .catch(err => {
                setError(err?.response?.data?.mensaje);
                setTimeout(() => {
                    setError(null);
                }, 5000);
            })
            .finally(
                () => setLoading(false)
            );
            */
    }

    const handleNavigateLogin = () => {
        navigate('/login');
    }

    return (
        <div className="grid w-full h-screen bg-gray-800 max-w place-items-center">
            <form className="w-8/12 px-8 pt-6 pb-8 mb-2 rounded shadow-md bg-slate-900 xl:w-3/12 sm:8/12 md:w-4/12" onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-bold text-gray-500" htmlFor="username">
                        Username
                    </label>
                    <input
                        className="w-full px-3 py-2 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="text"
                        id="username"
                        ref={userRef}
                        placeholder="Username"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-bold text-gray-500" htmlFor="password">
                        Password
                    </label>
                    <input
                        className="w-full px-3 py-2 mb-3 leading-tight text-gray-900 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        type="password"
                        id="password"
                        ref={passRef}
                        placeholder="************"
                        required
                    />
                </div>
                <div className="flex flex-col items-center justify-between gap-3">
                    <Button
                        type={'primary'}
                        width={'full'}
                        text={loading ? 'Cargando...' : 'Registrarse'}
                    />
                    {error && <Alert title={'Error'} text={error} />}
                    <span className="inline-block py-2 text-sm font-bold text-blue-500 align-baseline cursor-pointer hover:text-blue-800"
                        onClick={handleNavigateLogin}>
                        Ya tienes cuenta? Iniciar sesión
                    </span>
                </div>
            </form>
        </div>
    )
}

export default Register;